import { type RootState } from '../store';

export const selectIsMobile = (state: RootState) => state.app.isMobile;
export const selectTitle = (state: RootState) => state.app.title;
export const selectIcareKo = (state: RootState) => state.app.icareKo;
